<div *ngIf="page">
    <h1 font-bold>{{page.title}}</h1>
    <p>{{page.content}}</p>
  </div>
